import { forwardRef } from 'react'

import {
  adminRoutes,
  isAdminDesignRoutePathname,
  isAdminRoutePathname,
} from '@bettermode/domain/routes/web/admin'
import { T } from '@tribeplatform/react-components/i18n'
import { cn } from '@tribeplatform/react-components/utils/cn'
import { useRouter, useRouterPath } from '@tribeplatform/react-sdk'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useRouteModeAnchor } from '../useRouteModeAnchor.js'

import { AnchorComponentProps } from './index.js'

const AdminLink = forwardRef<HTMLAnchorElement, AnchorComponentProps>(
  (props, ref) => {
    const { Link } = useRouter()
    return <Link ref={ref} href={adminRoutes.site.root} {...props} />
  },
)
AdminLink.displayName = 'AdminLink'

export function AdminModeDropDownItem() {
  const anchor = useRouteModeAnchor()

  const Comp = anchor.admin ?? AdminLink

  return (
    <Dropdown.Item as={Comp} leadingIcon={<SvgIcon name="settings" />}>
      <T id="Generics.Administration" defaultMessage="Administration" />
    </Dropdown.Item>
  )
}

export function AdminModeSheetItem() {
  const pathname = useRouterPath()
  const anchor = useRouteModeAnchor()

  const isActive =
    isAdminRoutePathname(pathname) && !isAdminDesignRoutePathname(pathname)

  const Comp = anchor.admin ?? AdminLink

  return (
    <Comp
      className={cn('flex items-center gap-2 p-3', {
        'bg-surface pointer-events-none': isActive,
      })}
    >
      <SvgIcon name="settings" />
      <T id="Generics.Administration" defaultMessage="Administration" />
    </Comp>
  )
}
